/* eslint-env browser */
import * as React from 'react'

const PropTypes = require('prop-types')

const { replaceStorageByCdn } = require('../../../../../../shared/services/media-helper')

class LargeCustomProductItem extends React.PureComponent {
  constructor(props) {
    super(props)
    this.state = {}
  }

  render() {
    const { gear, productCategory } = this.props

    let imgUrl = replaceStorageByCdn(gear.mediaUrl_300)
    if (!imgUrl) {
      if (productCategory && productCategory.icon) {
        imgUrl = productCategory.icon.url_300
      }
    }
    const { fullName } = gear

    return (
      <div className="is-size-7-mobile content-card is-full-height">
        <figure className="image is-2by1">
          <img
            src={imgUrl}
            className="has-object-fit-contain"
            alt={`${productCategory.name} ${gear.brandName} ${fullName}`}
            title={`${productCategory.name} ${gear.brandName} ${fullName}`}
          />
        </figure>
        <div className="title is-8 has-text-weight-bold has-text-primary-blue has-text-centered is-uppercase">
          {gear.brandSeoName && <a href={`/gear/brands/${gear.brandSeoName}`}>{gear.brandName}</a>}
          {!gear.brandSeoName && <span>{gear.brandName}</span>}
        </div>
        <div className="subtitle is-8 is-uppercase has-text-centered">{fullName}</div>
      </div>
    )
  }
}

LargeCustomProductItem.propTypes = {
  gear: PropTypes.object.isRequired,
  productCategory: PropTypes.object.isRequired,
}

LargeCustomProductItem.defaultProps = {}

module.exports = LargeCustomProductItem
